module.exports = __webpack_public_path__ + "6bce3900731292d0eff6ea465add2eea.pdf";